import DetailsEditor from './DetailsEditor.gql';

export default DetailsEditor;
